import apiClient from '@/lib/API/client'

// What the rider chose on the page of a MOVE PRO file (P7). Sent with the file,
// it comes before the launch the server matches the file with; a file nobody
// set by hand names nothing, and the server proposes.
export const SENSOR_FILE_METADATA_MANUAL = 'manual'

const FIELDS = {
    horse_id: 'horseId',
    rider_id: 'riderId',
    discipline: 'discipline',
    goal: 'goal',
    goal_value: 'goal_value',
}

const isSet = (value) => value !== undefined && value !== null && String(value).trim() !== '' && value !== 'default'

// A file's discipline as its page shows it: '' when none was chosen ('default').
export const normalizeSensorFileDiscipline = (value) => (isSet(value) ? String(value) : '')

// The fields POST /uploads gets for a file, from its stored properties.
export const sensorFileMetadataFields = (properties) =>
    properties?.metadataSource === SENSOR_FILE_METADATA_MANUAL
        ? Object.fromEntries(
              Object.entries(FIELDS)
                  .map(([field, property]) => [field, properties[property]])
                  .filter(([, value]) => isSet(value))
          )
        : {}

// Once the file is sent: the Polar capture chosen on its page (null: « Aucun »)
// in place of the one the server proposed; nothing when none was chosen there.
// Kept on the file like its other choices. Never throws: a refusal leaves the
// proposal, still open to change when the session is confirmed, and the file
// counts as sent.
export const sendSensorFileHeartrateChoice = async (properties, sessionId) => {
    if (!(Number(sessionId) > 0) || properties?.heartrateUploadId === undefined) return
    try {
        await apiClient.put(`/sessions/${sessionId}`, { heartrate_upload_id: properties.heartrateUploadId })
    } catch (error) {
        console.warn('[SensorFile] Failed to set the chosen Polar capture on the session', error)
    }
}
